import { Flex, Grid, Typography } from 'antd';
import { ReactComponent as BigLogo } from 'assets/logo/logo-big.svg';
import clsx from 'clsx';
import React from 'react';
const { Title } = Typography;
const { useBreakpoint } = Grid;

export interface PageHeaderProps {
  title?: string;
  children?: React.ReactNode;
  right?: React.ReactNode;
  bottom?: React.ReactNode;
  align?: React.CSSProperties['alignItems'];
  hideLogo?: boolean; // pour cacher le logo sur la page des suivis des dossiers
}

const PageHeader = (props: PageHeaderProps) => {
  const { title, children, right, bottom, align, hideLogo } = props;
  const { xl, lg } = useBreakpoint();

  return (
    <>
      <Flex gap="large" align={align || 'start'}>
        {xl && !hideLogo && (
          <BigLogo className="print:hidden" style={{ minWidth: '285px' }} />
        )}

        <Flex vertical gap="large" className={'grow'}>
          <Flex vertical gap="large" align="flex-start">
            <Flex gap="large" justify="space-between" className="w-full">
              <Title
                level={1}
                className={clsx('!m-0', {
                  '!leading-none !text-2xl': hideLogo,
                })}
              >
                {title}
              </Title>
              {lg && right}
            </Flex>

            {children}
          </Flex>
          {bottom}
        </Flex>
      </Flex>
      {!lg && right}
    </>
  );
};

export default PageHeader;
